import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/ContactModal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_layout/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/education/_components/certifications/Certifications.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/education/_components/degree/Degree.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/education/_components/EduBody.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/education/PageClient.tsx");
